module.exports = __webpack_public_path__ + "img/dashboard-profile.118c8314.jpg";